<template>
    <div>
        <div v-html="value" v-if="!isEdit" :class="classes" @dblclick="toggle"></div>
        <div v-if="isEdit" class="flex flex-col">
            <vue-trix
                    v-model="value"
            >

            </vue-trix>
            <div class="flex justify-end">
                <button
                        class="mt-2 w-1/5 btn is-outlined"
                        @click="onSave"
                >
                    Salva
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    import VueTrix from "./VueTrix";
    import EditCell from "../../mixins/EditCell";

    export default {
        mixins: [EditCell],

        components: {VueTrix},

        methods: {
            onSave() {
                this.isClean = false;
                this.onBlur();
            }
        }
    }
</script>

<style scoped>

</style>